export enum NEWS_CATEGORY {
  PROJECT_NEWS,
  EVENTS,
  NOTES,
  MAINTENANCE,
}
